module.exports = __webpack_public_path__ + "static/media/content_copy.6ae97f0e.svg";